import React from 'react';
import type { HeadingProps, HeadingSize } from './interface';
import { BaseTypography } from '../BaseTypography';
import { getTestId } from '@src/utils/testIds';

type HeadingValues = {
  [key in HeadingSize]: {
    component: 'h1' | 'h2' | 'h3' | 'h4';
    fontSize: number;
    fontWeight: number;
    lineHeight: number;
  };
};

const HEADING_VALUES: HeadingValues = {
  l: {
    component: 'h1',
    fontSize: 28,
    fontWeight: 610,
    lineHeight: 40,
  },
  m: {
    component: 'h1',
    fontSize: 24,
    fontWeight: 610,
    lineHeight: 32,
  },
  s: {
    component: 'h3',
    fontSize: 20,
    fontWeight: 610,
    lineHeight: 28,
  },
  xs: {
    component: 'h4',
    fontSize: 18,
    fontWeight: 610,
    lineHeight: 24,
  },
};

export const Heading: React.FC<HeadingProps> = (props: HeadingProps) => {
  const { color, textAlign, children } = props;
  const { component, fontSize, fontWeight, lineHeight } = HEADING_VALUES[props.size];

  return (
    <BaseTypography
      color={color}
      fontSize={fontSize}
      fontWeight={fontWeight}
      lineHeight={lineHeight}
      letterSpacing={-0.01}
      textAlign={textAlign}
      $web={{ component }}
      testId={getTestId(props)}
    >
      {children}
    </BaseTypography>
  );
};
